import { WhaleuEntry } from '../../lib/api';

const SOURCE_ALIASES: Record<string, string> = {
  xydt: '南京大学院系动态',
  zhxw: '南京大学综合新闻',
};

const MATCH_LABELS: Record<string, string> = {
  college: '与你的学院有关',
  audience: '符合你的身份',
  topic: '命中关注主题',
};

export function cleanText(value?: string) {
  return String(value || '').replace(/&nbsp;|\[图片\]/g, ' ').replace(/\s+/g, ' ').trim();
}

export function sourceLabel(item: WhaleuEntry) {
  const source = cleanText(item.sourceName).replace(/【(?:未使用|停用|禁用)】\s*$/, '');
  return SOURCE_ALIASES[source] || source || '南京大学校园来源';
}

export function categoryLabel(item: WhaleuEntry) {
  const category = cleanText(item.category);
  if (category && !/^\d+$/.test(category) && !SOURCE_ALIASES[category]) return category;
  return item.tags?.find((tag) => tag !== '本院') || (item.kind === 'wechat' ? '公众号' : '校园资讯');
}

export function matchLabels(item: WhaleuEntry) {
  return (item.match || []).map((key) => MATCH_LABELS[key] || key);
}

export function safeSourceUrl(value?: string) {
  if (!value) return '';
  try {
    const parsed = new URL(value, window.location.origin);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : '';
  } catch { return ''; }
}

export function itemDate(item: WhaleuEntry) {
  const source = item.date || item.publishTime || '';
  if (!source) return '日期待核';
  const parsed = new Date(source.length === 10 ? `${source}T12:00:00+08:00` : source);
  if (Number.isNaN(parsed.getTime())) return source.slice(0, 10);
  return new Intl.DateTimeFormat('zh-CN', { month: 'numeric', day: 'numeric' }).format(parsed);
}
